<template>
  <div>
      <!-- 分割线 -->
    <div class="cut_off"></div>
    <div class="help_box">
      <!-- 左边区块 -->
      <div class="help_left">
        <!-- For-內容 -->
        <!-- 1 -->
        <div class="left_content">
          <!-- 標題 -->
          <div class="left_title">
            {{formHelp.title}}
            <div class="left_title_author">
              作者：{{formHelp.author}}
            </div>
          </div>
          <!-- 標題-end -->
          <!-- 描述內容 -->
          <div class="left_describe">
            <!-- 內容： -->
            <p v-html="formHelp.content"></p>
            <p class="left_describe_p">
              我是内容。。。。【对应 {{formHelp.title}} 】
            </p>



            <!-- <p v-show="formHelp.contentTF">
              您需要购买一个域名（服务器经销商一般也会提供相关服务），必须是备案后的，微信那边对备案有要求，阿里云、腾讯云对备案也有要求。非备案的域名几乎是不能正常使用了。
            </p>
            <p class="left_describe_p" v-show="formHelp.contentTF">
              <span>
                  GIT地址：http://git.oschina.net/we7coreteam/pros
              </span>
              <span>
                  GIT地址：http://git.oschina.net/we7coreteam/pros
              </span>
            </p> -->
            <h1>
              其它实例Git地址
            </h1>
            <div class="list_box">
              <h3>最新编辑列表</h3>
              <!-- 跳转系列： -->
              <ul>
                <li v-for="(item, index) in menuLists[2]" :key="index">
                  <a @click="clickFun('入門教程(暂时简体，会改)')">{{item.name}}</a>
                  <span>{{item.time}}</span>
                </li>
              </ul>
            </div>
          </div>
          <!-- 描述內容-end -->
        </div>
        <!-- For-內容-end -->
      </div>
      <!-- 左边区块-end -->
      <!-- 右边区块 -->
      <div class="help_right">
        <!-- 目錄 -->
        <el-tabs type="border-card" class="help_right_menu">
          <!-- 1 -->
          <el-tab-pane>
            <span slot="label"><i class="el-icon-sort"></i> 目錄</span>
              <!-- 目錄-內容 -->
            <el-menu
              :default-active="indexTF"
              class="el-menu-vertical-demo"
              @select="handleOpen">
              <el-submenu :index="item.id" v-for="item in menuLists[0]" :key="item.id">
                <template slot="title">
                  <!-- <i class="el-icon-location"></i> -->
                  <span>{{item.name}}</span>
                </template>
                  <el-menu-item :index=" item.id+'-'+item2.id " v-for="item2 in item['two']" :key="item2.id">{{item2.name}}</el-menu-item>
                  <!-- 如果有下级，再说： -->
                  <!-- <el-submenu index="1-4">
                    <template slot="title">網站相關</template>
                      <el-menu-item index="1-4-1">大法官</el-menu-item>
                  </el-submenu> -->
              </el-submenu>


            <!--  -->
              

              <!-- <el-menu-item index="2">
                <i class="el-icon-menu"></i>
                <span slot="title">导航二</span>
              </el-menu-item>
              <el-submenu index="3">
                <template slot="title">
                  <i class="el-icon-document"></i>
                  <span>导航三</span>
                </template>
                  <el-menu-item index="3-1">选项1</el-menu-item>
                  <el-menu-item index="3-2">选项2</el-menu-item>
                <el-submenu index="3-3">
                  <template slot="title">选项3</template>
                  <el-menu-item index="3-3-1">选项1</el-menu-item>
                  <el-menu-item index="我是谁？">我是谁？</el-menu-item>
                </el-submenu>
                <el-menu-item index="3-4">选项4</el-menu-item>
              </el-submenu>
              <el-menu-item index="导航四">
                <i class="el-icon-setting"></i>
                <span slot="title">导航四</span>
              </el-menu-item> -->
            </el-menu>
            
          </el-tab-pane>
          <!-- 1-end -->
          <!-- 2 -->
          <el-tab-pane>
            <span slot="label"><i class="el-icon-search"></i> 搜索</span>
              <div>
                <el-input class="el_input" placeholder="請輸入要搜索的問題" v-model="searchInput" >
                  <el-button slot="append" icon="el-icon-search"></el-button>
                </el-input>
              </div>
          </el-tab-pane>
          <!-- 2-end -->
        </el-tabs>
      </div>
      <!-- 右边区块-end -->
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Help',
  props: {
    
  },
  data() {
    return {
      searchInput: '',
      // 默认选择：
      indexTF: '',
      activeIndex: '1',
      formHelp: {
        title: '幫助中心',
        author: '台易購',
        contentTF: true,
      },
      // 菜单：
      menuLists: [],
      // 内容：
      contentList: [],
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      // console.log('keyPath：' + keyPath);
      // console.log('key值：' + key);
      this.showFun(keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    clickFun(index){
      // this.indexTF = index;
      // this.formHelp.title = index;
    },
    showFun(path){
      // 
      for(let i=0; i<this.menuLists[1].length; i++){

        if(this.menuLists[1][i].id == path[0]){
          // console.log(this.menuLists[1][i].name);
          this.contentList = this.menuLists[1][i];
        }
      }
      // 是否有值
      if(path[1]){
        let str = path[1];
        str = str.split("-");

        // FOR:
        for(let i=0; i<this.contentList['two'].length; i++){
          // 内容赋值：
          if(this.contentList['two'][i].id == str[1]){
            this.formHelp = this.contentList['two'][i];
          }
        }
        // console.log(this.formHelp);
      }
    },

  },
  mounted() {
    axios.get(this.$store.state.axiosAutoHelpUrl, {
            params: {
              // action: 1,
              // uid: this.$store.state.uid
            }
          }).then( res =>{
            // console.log(res.data.message[1]);
            this.menuLists = res.data.message;
          })
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*  */
  .cut_off {
    height: 4px;
    background: #e73262;
    margin-bottom: 30px;
  }
  .el-menu-vertical-demo {
    min-height: 550px;
  }
/* BOX */
  .help_box {
    width: 1200px;
    margin: 0 auto;
    border: 1px solid #c7c7c7;
    display: flex;
    margin-bottom: 30px;
    min-height: 550px;
  }
  .el_input {
    height: 20px;
  }
/* 左邊區塊 */
  .help_left {
    flex: 1;
    color: #333;
  }
  /* 文章標題 */
  .left_title {
    height: 74px;
    line-height: 74px;
    font-size: 23px;
    position: relative;
    text-align: center;
    margin: 0 20px;
    border-bottom: 1px solid #c7c7c7;
  }
  .left_title_author {
    color: #777;
    font-size: 19px;
    position: absolute;
    right: 0px;
    top: 0px;
  }
  .left_describe {
    font-size: 13px;
    margin: 0 20px;
  }
  .left_describe > p {
    margin: 20px 0;
    line-height: 23px;
  }
  .left_describe > h1 {
    margin: 20px 0;
    line-height: 23px;
    font-size: 19px;
  }
  .left_describe_p {
    color: #e73262;
    border-left: 4px solid #e73262;
    overflow: hidden;
    padding: 5px 5px 5px 15px;
    background: rgba(255, 204, 204, .5);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .left_describe_p > span {
    display: block;
  }
  /* 最新編輯列表 */
  .list_box {
    margin: 20px 0;
  }
  .list_box > h3 {
    font-size: 17px;
    margin-bottom: 7px;
    font-weight: 500;
  }
  .list_box > ul {
    font-size: 13px;
    display: flex;
    flex-wrap: wrap;
  }
  .list_box > ul > li {
    width: 50%;
    box-sizing: border-box;
    display: inline-block;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
  }
  .list_box > ul > li > a, .list_box > ul > li > span {
    display: inline-block;
    line-height: 19px;
    color: #333;
  }
  .list_box > ul > li > a {
    cursor: pointer;
  }
  .list_box > ul > li > span {
    padding-right: 10px;
  }
/* 右邊區塊 */
  .help_right {
    width: 350px;
  }
  .help_right_menu {
    min-height: 400px;
  }
</style>
